L.PopUpDl = L.Popup.extend({

    _initLayout: function ()
    {
        var prefix = 'popup-dl leaflet-popup',
            containerClass = prefix + ' ' + this.options.className + ' leaflet-zoom-' + (this._animated ? 'animated' : 'hide'),
            container = this._container = L.DomUtil.create('div', containerClass),
            closeButton;

        if (this.options.closeButton)
        {
            closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
            closeButton.href = '#close';
            closeButton.innerHTML = '&#215;';
            L.DomEvent.disableClickPropagation(closeButton);

            L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
        }

        var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
        L.DomEvent.disableClickPropagation(wrapper);

        this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);

        L.DomEvent.disableScrollPropagation(this._contentNode);
        L.DomEvent.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);

        this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
        this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
    },

    _adjustPan: function ()
    {
        var map = this._map,
            containerHeight = this._container.offsetHeight,
            containerWidth = this._containerWidth,
            layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);

        if (this._animated)
        {
            layerPos._add(L.DomUtil.getPosition(this._container));
        }

        var containerPos = map.layerPointToContainerPoint(layerPos),
            padding = L.point(this.options.autoPanPadding),
            paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
            paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
            size = map.getSize(),
            dx = 0,
            dy = 0;

        if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
            dx = containerPos.x + containerWidth - size.x + paddingBR.x;
        }
        if (containerPos.x - dx - paddingTL.x < 0) { // left
            dx = containerPos.x - paddingTL.x;
        }
        if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
            dy = containerPos.y + containerHeight - size.y + paddingBR.y;
        }
        if (containerPos.y - dy - paddingTL.y < 0) { // top
            dy = containerPos.y - paddingTL.y;
        }

        if (dx || dy)
        {
            if (this.options.autoPan)
            {
                map
                    .fire('autopanstart')
                    .panBy([dx, dy]);
            }
            else
            {
                // console.log('_adjustPan() w:', containerWidth, 'h:', containerHeight, 'dx:', dx, 'dy:', dy);
                var $c_wrap = $('.popup-dl.leaflet-popup-content-wrapper');
                var $t_wrap = $('.popup-dl.leaflet-popup-tip-container');
                var $t      = $('.popup-dl.leaflet-popup-tip');

                if (dx != 0)
                {
                    $c_wrap.css('left', -dx + 'px');
                    if (containerWidth / 2 - Math.abs(dx) < 10)
                    {
                        var bord_prop, float_val, m_val;
                        if (dx > 0)
                        {
                            float_val = 'right';
                            m_val = 9;

                            if (dy < 0)
                            {
                                bord_prop = 'border-top-right-radius';
                                m_val = '-8px 11px 11px -8px';
                            }
                            else
                            {
                                bord_prop = 'border-bottom-right-radius';
                                m_val = '-8px 11px 11px 32px';
                            }
                        }
                        else
                        {
                            float_val = 'left';
                            m_val = -9;

                            if (dy < 0)
                            {
                                bord_prop = 'border-top-left-radius';
                                m_val = '-8px 11px 11px 32px';
                            }
                            else
                            {
                                bord_prop = 'border-bottom-left-radius';
                                m_val = '-8px 11px 11px -8px';
                            }
                        }

                        $c_wrap.css(bord_prop, '0');
                        $t_wrap.css('float', float_val);
                        $t_wrap.css('left', -dx + 'px');
                        $t.css('margin', m_val);
                    }
                }

                if (dy < 0)
                {
                    $c_wrap.css('top', (containerHeight + 60) + 'px');
                    $t_wrap.css('top', (60) + 'px');
                    $t_wrap.css('transform', 'rotate(180deg)');
                }
            }
        }
    }

});

L.popUpDl = function(options)
{
    var o = new L.PopUpDl(options);
    return o;
};

L.Control.ScaleDl = L.Control.Scale.extend({

    _getScaleWidth: function (ratio) {
        return Math.round(this.options.maxWidth * ratio);
    },

});

L.Control.scaleDl = function(options)
{
    var o = new L.Control.ScaleDl(options);
    return o;
};